import { Typography } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import renderMarkdown from '../../server/utils/renderMarkdown';
import { useRuntimeConfig } from '../runtimeConfig';
import breakpoints from '../utilities/breakpoints';
import useTranslatedString from '../utilities/useTranslatedString';
import { useCompany } from './contexts/CompanyContextManager';

const { Text } = Typography;

export const PorscheFooterContainer = styled.div<{ show: boolean }>`
    width: 100%;
    background-color: #000000;
    color: #ffffff;
    padding: 24px 50px;
    display: ${props => (props.show ? 'block' : 'none')};

    @media screen and (max-width: ${breakpoints.md}) {
        padding: 24px;
    }

    & a:link,
    a:visited {
        color: white;
        text-decoration: underline;
    }

    & a:hover,
    a:active {
        color: rgb(255, 2, 35);
        text-decoration: underline;
    }
`;

const CopyrightContainer = styled(Text)`
    color: #ffffff;

    & .ant-typography {
        color: #ffffff;
        margin-bottom: 0;
    }
`;

const VersionContainer = styled(Text)`
    margin-right: 5px;
    color: #222;
`;

type PorscheFooterProps = {
    show?: boolean;
};

const PorscheFooter = ({ show }: PorscheFooterProps) => {
    const company = useCompany(true);
    const { t } = useTranslation('common');
    const translated = useTranslatedString();
    const { version } = useRuntimeConfig();
    const copyright = useMemo(() => {
        const currentYear = new Date().getFullYear();

        return company
            ? translated(company?.copyright).replace('{{currentYear}}', currentYear.toString())
            : 'Appvantage';
    }, [company, translated]);

    return (
        <PorscheFooterContainer show={show}>
            <CopyrightContainer>{renderMarkdown(copyright)}</CopyrightContainer>
            <VersionContainer>{t('common:copyrightVersion', { version })}</VersionContainer>
        </PorscheFooterContainer>
    );
};

export default PorscheFooter;
